export default __webpack_public_path__ + "static/media/discount.03cd8601.svg";